// extracted by mini-css-extract-plugin
export default {"shop_category_container":"ShopByAllCategories_shop_category_container__ErPzd"};